import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styles from './ExcessiveTradingPolicyNote.module.scss';
import '../../Buy/BuyFlow/ExpandedFundList//MarketVolatilityNote.scss';
import { getHasTaxableFunds } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import TRP from '../TRP/TRP';
import {
  isSell,
  isBuy,
  isExchange,
  isAutoExchange,
  isAutomaticSell,
} from '../../../utils/transactions-util';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';

const ExcessiveTradingPolicyNote = ({
  isSalesforceRep,
  customerWebViewEnabled,
  hasTaxableFunds,
}) => {
  const excessiveTradingPolicyNoteTitle = 'excessive-trading-policy-note-title';
  return (
    <div
      className={
        !isBuy() && !customerWebViewEnabled && isSalesforceRep
          ? 'market-volatility-note-box'
          : ''
      }
    >
      <div
        className={
          !customerWebViewEnabled && isSalesforceRep
            ? 'market-volatility-note'
            : styles['excessive-trading-policy-note']
        }
      >
        {hasTaxableFunds &&
          (isSell() ||
            isExchange() ||
            isAutoExchange() ||
            isAutomaticSell()) && (
            <div className={`${styles['non-covered-shares-note']}`}>
              <span className={`${styles[excessiveTradingPolicyNoteTitle]}`}>
                {!customerWebViewEnabled && isSalesforceRep ? (
                  <span>
                    Only for Taxable Non-Money Market Covered Share Redemptions
                    Using Average Cost:
                  </span>
                ) : (
                  <span>Please note:</span>
                )}
              </span>{' '}
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span>You</span>
              ) : (
                <span>
                  If you are redeeming covered shares using the Average Cost
                  method, and you proceed with this method, you
                </span>
              )}{' '}
              will not be able to revoke Average Cost for these remaining
              covered shares, and the cost basis of the covered shares you
              currently hold in this fund will be calculated using Average Cost.{' '}
              {!customerWebViewEnabled && isSalesforceRep && (
                <span className={`${styles[excessiveTradingPolicyNoteTitle]}`}>
                  Only for Taxable Redemptions:{' '}
                </span>
              )}
              {!isAutoExchange() && !isAutomaticSell() && !isSell() && (
                <>
                  Noncovered shares will be redeemed before covered shares
                  unless you request a redemption using the Specific Lot
                  Identification (SLID) method.
                </>
              )}
            </div>
          )}
        {!(isBuy() && !customerWebViewEnabled && isSalesforceRep) && (
          <span>
            <span className={`${styles[excessiveTradingPolicyNoteTitle]}`}>
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span>
                  Only for Redemptions and Exchanges in Excess of $5000 (Except
                  Money Markets and Ultra Short Term Bond Fund):
                </span>
              ) : (
                <span>Our Excessive Trading Policy:</span>
              )}
            </span>{' '}
            As stated in the funds' prospectuses and subject to certain
            exceptions, each 
            <TRP /> fund restricts a shareholder's purchases (including through
            exchanges) into a fund account for a period of 30 calendar days
            after the shareholder has redeemed or exchanged out of that same
            fund account {!isSell()
              ? 'for any amount greater than $5,000'
              : ''}{' '}
            ("30-Day Purchase Block").{' '}
            {isSell()
              ? "Generally, transactions of $5,000 or less are not subject to the 30-Day Purchase Block. Please see the fund's prospectus for more information. "
              : ''}
            The calendar day after the date of redemption is considered Day 1
            for purposes of computing the period before another purchase may be
            made. Automatic transactions (such as Automatic Asset Builder,
            automatic exchanges, and automatic withdrawals) generally are exempt
            from the policy. Checkwriting redemptions and transactions solely in
            money market funds are exempt from this policy.
          </span>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    hasTaxableFunds: getHasTaxableFunds(state),
  };
};

export default compose(connect(mapStateToProps))(ExcessiveTradingPolicyNote);
